import { useEffect, useRef, useState } from "react";
import { InventoryRawMaterialViewModel } from "../../../viewmodels/inventory/rawMaterial/InventoryRawMaterialViewModel";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { InputText } from "primereact/inputtext";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import SelectMenu from "../../../components/controls/SelectMenu";

function InventoryRawMaterialScreen(props) {
  const { logout } = props;
  const {
    getInStockRawMaterial,
    loading,
    products,
    onUpdateReceivingItemStock,
    getProductTypes,
    productTypeOptions,
    exportNetSuiteRawInventoryCsv,
    subRowDetails,
    loadingRows,
    fetchSubRowDetails,
  } = InventoryRawMaterialViewModel(logout);

  var currentPage = 1;
  const [filter, setFilter] = useState(-1);
  useEffect(() => {
    getInStockRawMaterial(null, currentPage, filter);
    getProductTypes();
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getInStockRawMaterial(searchRef.current.value, currentPage, filter);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getInStockRawMaterial(searchRef.current.value, currentPage, filter);
  };

  const [expandedRows, setExpandedRows] = useState(null);

  const allowExpansion = (rowData) => {
    return true;
  };

  const onRowExpand = async (event) => {
    const rowData = event.data;
    const key = String(rowData.id);
    if (subRowDetails[key] === undefined) {
      await fetchSubRowDetails(rowData);
    }
  };

  const parentTotalCostTemplate = (data) => {
    return <div>${data.total_cost}</div>;
  };

  const subItemUnitCostTemplate = (data) => {
    return <div>${data.unit_cost}</div>;
  };

  const subItemTotalCostTemplate = (data) => {
    return <div>${data.total_cost}</div>;
  };

  const headerTemplate = (data) => {
    return (
      <div className="px-1 py-2">
        <span className="text-xs font-bold uppercase tracking-wider text-gray-800">
          {data.category_name}
        </span>
      </div>
    );
  };

  const onCellEditComplete = (e) => {
    let { rowData, rowIndex, newValue, field, originalEvent: event } = e;

    switch (field) {
      default:
        if (newValue.trim().length > 0) {
          const oldItemCost = rowData.total_cost;
          const newItemCost = (
            parseFloat(newValue) * parseFloat(rowData.unit_cost)
          ).toFixed(2);

          rowData[field] = parseFloat(newValue).toFixed(2);
          rowData["total_cost"] = newItemCost;
          onUpdateReceivingItemStock(
            rowData.id,
            parseFloat(newValue),
            rowData.old_in_stock,
            rowData.parent_index,
            oldItemCost,
            newItemCost,
          );
        } else {
          event.preventDefault();
        }
        break;
    }
  };

  const textEditor = (options) => {
    return (
      <InputText
        type="text"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const rowExpansionTemplate = (data) => {
    const key = String(data.id);
    const detailRows = subRowDetails[key];
    const showSpinner =
      loadingRows[key] || detailRows === undefined;

    if (showSpinner) {
      return (
        <div className="flex justify-center rounded-lg bg-gray-50 p-6">
          <ProgressSpinner style={{ width: "36px", height: "36px" }} />
        </div>
      );
    }

    return (
      <div className="rounded-lg bg-gray-50 p-3">
        <DataTable
          value={detailRows}
          tableClassName="min-w-full divide-y divide-gray-200 rounded-md bg-white raw-inventory-table-child"
          cellClassName="px-2 py-2 text-sm border-b border-gray-200 bg-white"
          editMode="cell"
        >
          <Column field="supplier_name" header="Supplier Name" />
          <Column field="invoice_number" header="Invoice Number" />
          <Column field="product_name" header="Product Name" />
          <Column header="Unit Cost" body={subItemUnitCostTemplate} />
          <Column
            field="in_stock"
            header="Total Unit"
            editor={(options) => textEditor(options)}
            onCellEditComplete={onCellEditComplete}
          />
          <Column header="Total Cost" body={subItemTotalCostTemplate} />
        </DataTable>
      </div>
    );
  };

  return (
    <div>
      <div className="mt-2 px-4 sm:px-6 lg:px-8">
        <div className="rounded-xl border border-gray-200 bg-white px-4 py-5 shadow-sm sm:flex sm:items-start sm:justify-between">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              In stock Raw Material
            </h1>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <div className="flex w-[350px] flex-grow items-stretch">
                <div className="relative flex h-10 flex-grow items-stretch focus-within:z-10">
                  <input
                    type="search"
                    name="searchReceivingInvoice"
                    id="searchReceivingInvoice"
                    className="block w-full rounded-l-md border border-gray-300 px-3 text-sm text-gray-700 placeholder:text-gray-400 focus:border-main-purple focus:outline-none focus:ring-1 focus:ring-main-purple"
                    placeholder="Search by BOM name or plu"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="relative -ml-px inline-flex h-10 items-center justify-center rounded-r-md border border-gray-300 bg-gray-50 px-4 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-main-purple"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-500"
                    aria-hidden="true"
                  />
                </button>
              </div>
              <SelectMenu
                handleInputChange={(e) => {
                  const newFilter = e.target.value.value;
                  getInStockRawMaterial(
                    searchRef.current.value,
                    currentPage,
                    newFilter,
                  );
                  setFilter(newFilter);
                }}
                parentClass="w-56 min-w-[14rem]"
                placeholder="Product type"
                name="product_type"
                options={productTypeOptions}
                showLabel={false}
              />
            </div>
          </div>
          <div className="mt-4 rounded-lg bg-gray-50 p-3 sm:ml-8 sm:mt-0 sm:flex-none">
            {/* <button
                type="button"
                className="block rounded-md bg-main-purple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Add user
              </button> */}
            <h1 className="text-sm font-semibold leading-6 text-gray-700">
              Total Raw In Stock{" "}
              <span className="font-bold text-green-700">
                ${products.totalStockDollarAmount}
              </span>
            </h1>
            <h1 className="text-sm font-semibold leading-6 text-gray-700">
              Page Total Raw In Stock{" "}
              <span className="font-bold text-green-700">
                ${products.totalPageStockDollarAmount}
              </span>
            </h1>
            <button
              type="button"
              className="mt-2 block rounded-md bg-main-purple px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={exportNetSuiteRawInventoryCsv}
            >
              Export CSV
            </button>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              {loading ? (
                <div className="overflow-hidden rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                  <div className="animate-pulse space-y-3">
                    <div className="h-4 w-48 rounded bg-gray-200" />
                    <div className="h-10 w-full rounded bg-gray-100" />
                    <div className="h-10 w-full rounded bg-gray-100" />
                    <div className="h-10 w-full rounded bg-gray-100" />
                  </div>
                </div>
              ) : (
                <div className="card-custom overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                  <DataTable
                    value={products.data}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                      setExpandedRows(e.data);
                    }}
                    onRowExpand={onRowExpand}
                    rowExpansionTemplate={rowExpansionTemplate}
                    dataKey="id"
                    tableClassName="min-w-full divide-y divide-gray-200 bg-white text-sm raw-inventory-table-parent"
                    cellClassName="p-3 border-b border-gray-200 text-sm bg-white"
                    rowGroupMode="subheader"
                    groupRowsBy="category_name"
                    rowGroupHeaderTemplate={headerTemplate}
                    scrollHeight="100%"
                  >
                    <Column field="bom_plu" header="Bom Plu" />
                    <Column field="bom_name" header="Bom Name" />
                    <Column
                      field="total_stock"
                      header="Amount in stock"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      field="unit_of_measure"
                      header="Unit of Measure"
                      style={{ textAlign: "right" }}
                    />
                    <Column
                      header="Total Cost"
                      body={parentTotalCostTemplate}
                      style={{ textAlign: "right" }}
                    />
                    {/* <Column header="" body={massItemActionTemplate} /> */}
                    <Column
                      expander={allowExpansion}
                      style={{ width: "5rem" }}
                    />
                  </DataTable>
                </div>
              )}
            </div>
            <div className="w-full border-t border-gray-200 pt-3">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={products.total}
                // rowsPerPageOptions={[10, 20, 30]}
                onPageChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InventoryRawMaterialScreen),
);
